import { NgModule } from '@angular/core';

import { ReportsContainerComponent } from './reports.container';
import { SharedModule } from '../../shared/shared.module';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ReportsEffects } from './reports.effects';
import { FieldModule } from 'atlas-field';
import { IconModule } from 'atlas-icon';
import { ButtonModule } from 'atlas-button';
import { CheckboxModule } from 'atlas-checkbox';
import { TooltipModule } from 'atlas-tooltip';
import { CdkModule, DATE_FORMATS, DATE_LOCALE } from 'atlas-cdk';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
export const COMPONENTS = [
  ReportsContainerComponent
];

const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'dd/M/yyyy',
  },
  display: {
    ateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    dateInput: { year: 'numeric', month: '2-digit', day: '2-digit' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
    monthYearLabel: { year: 'numeric', month: 'short' },
  },
};

@NgModule({
  declarations: COMPONENTS,
  imports: [
    FormsModule,
    CommonModule,
    SharedModule,
    // // MercerOSModule,
    FieldModule,
    IconModule,
    ButtonModule,
    CheckboxModule,
    TooltipModule,
    CdkModule,
    EffectsModule.forFeature([ReportsEffects])
  ],
  exports: COMPONENTS,
  providers: [
    { provide: DATE_LOCALE, useValue: 'en-US' },
    { provide: DATE_FORMATS, useValue: MY_DATE_FORMAT },
  ], bootstrap: [],
})
export class ReportsModule {
}
